import React, { Component } from "react";
import { Container } from "reactstrap";
import { Styled } from "../../../toolkit/decorators/Artifact";
import s from "./styles.scss";
import FormBuilder from "../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./ExternosList.form";
import { MemoTable } from "./ExternosList.table";
import ExternoDetalle from "../../../types/ExternoDetalle";
import { deleteEmptyProps } from "../../../toolkit/utils/filter-utils";
import { errorNotification } from "../../../utils/notifications";
import { ExternosListStore } from "../../containers/externoList/ExternosList.store";
import { ExternosListDispatcher } from "../../containers/externoList/ExternosList.dispatcher";

interface Props extends ExternosListStore, ExternosListDispatcher {}

interface State {
  filters: any & { page: number; size: number };
}

@Styled(s)
export default class ExternosListComponent extends Component<Props, State> {
  state: State = {
    filters: { page: 0, size: 50 }
  };

  submit = (values: any) => {
    this.fetchData({ page: 0 } as any, null, values);
  };

  fetchData = async (
    { pageSize: tablePageSize, page: tablePage },
    _?: any,
    formFilters?
  ) => {
    const filters = formFilters || this.state.filters;
    const page = tablePage >= 0 ? tablePage : this.state.filters.page;
    const size = tablePageSize >= 0 ? tablePageSize : this.state.filters.size;
    const pageableFilters = deleteEmptyProps({ ...filters, page, size });

    // Solo evita la primera consulta
    if (!pageableFilters.tipoBusqueda && !pageableFilters.nombre) {
      return;
    }

    this.setState({ filters: pageableFilters });

    let preview;
    switch (filters.tipoBusqueda) {
      case "ID":
        preview = await this.props.getExternosDetalleByIdPersona(
          Number(filters.idPersona),
          { page, size }
        );
        break;
      case "CURP":
        preview = await this.props.getExternosDetalleByCurp(filters.curp, {
          paramCurp: filters.paramCurp,
          page,
          size
        });
        break;
      default:
        preview = await this.props.getExternosDetalleByFilters({
          nombre: filters.nombre,
          paramNombre: filters.paramNombre,
          fechaNacimiento: filters.fechaNacimiento,
          soloExternos: !!filters.soloExternos,
          page,
          size
        });
        break;
    }

    if (!preview.fulfilled) {
      errorNotification(
        preview.gettingExternosDetalleError || "Error al obtener Externos"
      );
    }
  };

  render() {
    return (
      <Container className="mb-5">
        <FormBuilder<Inputs, Buttons>
          config={formConfig}
          submit={this.submit}
          processing={this.props.gettingExternosDetalle}
        />

        <hr className="row" />

        <MemoTable
          page={this.props.externosDetalle || ({} as Page<ExternoDetalle>)}
          loading={this.props.gettingExternosDetalle}
          onFetchData={this.fetchData}
        />
      </Container>
    );
  }
}
